// data/roadmapSteps.js
// داده نمونه نقشه‌راه — export برای استفاده در صفحه
export const DEFAULT_ROADMAP = [
  { id: 1, title: "آشنایی با جشنواره", date: null, details: "معرفی کلی جشنواره و اهداف آن." },
  { id: 2, title: "بررسی نیازهای صنعت آب و برق", date: null, details: "تحلیل نیازهای صنعت و چالش‌ها." },
  { id: 3, title: "شروع ثبت نام در محور مورد نظر", date: "۱۴۰۴/۰۹/۰۱", details: "شروع ثبت‌نام آنلاین در سامانه." },
  { id: 4, title: "آماده سازی طرح و ارسال پروپوزال", date: null, details: "ارسال پروپوزال مطابق محور ثبت نامی." },
  { id: 5, title: "انجام داوری اولیه", date:  "۱۴۰۴/۱۱/۰۱", details: "اعلام نتیجه داوری اولیه طرح ها" },
  { id: 6, title: "ارائه حضوری طرح‌ها در جشنواره", date: "۲۷ و ۲۸ بهمن ماه ۱۴۰۴", details: "جلسات ارائه و پنل‌ها." },
  { id: 7, title: "اهدای جوایز", date: null, details: "اعطای جوایز و تقدیر از برندگان." },
  { id: 8, title: "زمان‌بندی عقد قراردادها", date: null, details: "پیگیری و عقد قرارداد با منتخبین." },
];

export default DEFAULT_ROADMAP;
